/* Scoped to the merchant-selected product and its native purchase form. */
if (!customElements.get('cwm-subscription-choice')) {
  customElements.define('cwm-subscription-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      if (document.readyState === 'loading') {
        this.ready = () => this.initialize();
        document.addEventListener('DOMContentLoaded', this.ready, { once: true });
      } else this.initialize();
    }
    initialize() {
      this.form = document.getElementById(this.dataset.formId);
      if (!this.form || this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.switch = this.querySelector('[data-cwm-switch]');
      this.plans = JSON.parse(this.querySelector('[data-cwm-plans]').textContent);
      this.switch.addEventListener('click', () => {
        this.switch.setAttribute('aria-checked', String(this.switch.getAttribute('aria-checked') !== 'true'));
        this.sync();
      }, options);
      this.form.addEventListener('change', () => this.sync(), options);
      this.closest('.shopify-section')?.addEventListener('change', event => {
        if (event.target.form === this.form) this.sync();
      }, options);
      this.form.addEventListener('variant:changed', () => this.sync(), options);
      this.form.addEventListener('submit', () => this.sync(), { ...options, capture: true });
      this.form.addEventListener('formdata', event => {
        const plan = this.selectedPlan();
        if (plan) event.formData.set('selling_plan', plan);
        else event.formData.delete('selling_plan');
      }, options);
      this.sync();
    }
    selectedPlan() {
      // Tier radios live outside the form and are associated through form="...".
      const variants = [...this.form.elements].filter(input => input.name === 'id' && !input.disabled);
      const variant = variants.find(input => input.checked) || variants[0];
      const plan = this.plans[variant?.value]?.[0];
      return this.switch.getAttribute('aria-checked') === 'true' && plan ? String(plan) : '';
    }
    sync() {
      this.switch.classList.toggle('active', this.switch.getAttribute('aria-checked') === 'true');
      const plan = this.selectedPlan();
      const inputs = [...this.form.querySelectorAll('[name="selling_plan"]')];
      let input = inputs.shift();
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        this.form.append(input);
      }
      inputs.forEach(extra => { extra.disabled = true; });
      input.value = plan;
      input.disabled = !plan;
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.ready);
      this.abort?.abort();
      this.abort = null;
    }
  });
}
